<template>
	<dl>
		<dt>maxOrdersMarksValue</dt>
		<dd i18n>Нельзя заказать более 3 000 кодов маркировки на один GTIN. Измените значение в поле "Количество"</dd>
		<dt>min</dt>
		<dd i18n>При заказе должно быть указано количество кодов маркировки. Введите значение (отличное от 0) в поле</dd>
		<dt>onlyBLRWBL</dt>
		<dd i18n>Реестр для ТН сформировать невозможно. Выберите только ТТН.</dd>
		<dt>isMoreOfToday</dt>
		<dd i18n>должна быть не более текущей даты</dd>
		<dt>isSmallerOfToday</dt>
		<dd i18n>должна быть не раньше текущей даты</dd>
		<dt>onlySender</dt>
		<dd i18n>Реестр может сформировать только грузоотправитель</dd>
		<dt>sentDocumentMessage</dt>
		<dd i18n>Документ обрабатывается. Страница будет обновлена.</dd>
		<dt>storageNotActive</dt>
		<dd i18n>Выбранный Вами склад более недоступен. Страница будет обновлена.</dd>
		<dt>editInvitation</dt>
		<dd i18n>Приглашение успешно отредактировано.</dd>
		<dt>sendInvitation</dt>
		<dd i18n>Приглашение(-я) успешно обработано(-ы).</dd>
		<dt>deleteInvitation</dt>
		<dd i18n>Приглашение успешно удалено.</dd>
		<dt>sendSuccess</dt>
		<dd i18n>Документ успешно отправлен.</dd>
		<dt>documentQueuedSending</dt>
		<dd i18n>Документ поставлен в очередь на отправку.</dd>
		<dt>markAsReadSuccess</dt>
		<dd i18n>Документы помечены как прочитанные.</dd>
		<dt>acceptSuccess</dt>
		<dd i18n>Документ успешно принят.</dd>
		<dt>signSuccess</dt>
		<dd i18n>Документ успешно подписан.</dd>
		<dt>singAndSaveOk</dt>
		<dd i18n>Документ успешно подписан и отправлен.</dd>
		<dt>cancelSuccess</dt>
		<dd i18n>Документ успешно отменен.</dd>
		<dt>cancelDocumentQueuedSend</dt>
		<dd i18n>Отмена на документ поставлена в очередь на отправку.</dd>
		<dt>changeRequiredNotConfirmedCancelError</dt>
		<dd i18n>Накладная не может быть отменена при неподтвержденном требовании изменений.</dd>
		<dt>rejectSuccess</dt>
		<dd i18n>Документ успешно отклонён.</dd>
		<dt>confirmCancel</dt>
		<dd i18n>Отмена документа успешно подписана и отправлена.</dd>
		<dt>confirmReceiptOk</dt>
		<dd i18n>Подтверждение о получении успешно отправлено.</dd>
		<dt>receiptConfirmationQueuedDispatch</dt>
		<dd i18n>Подтверждение о получении поставлено в очередь на отправку.</dd>
		<dt>confirmReceiptCancel</dt>
		<dd i18n>Подтверждение получения отмены успешно отправлено.</dd>
		<dt>confirmReceiptEdit</dt>
		<dd i18n>Подтверждение получения запроса на изменение успешно отправлено.</dd>
		<dt>editSuccess</dt>
		<dd i18n>Изменение документа успешно подписано и отправлено.</dd>
		<dt>changeNotificationQueuedSent</dt>
		<dd i18n>Уведомление об изменении поставлено в очередь на отправку.</dd>
		<dt>editSuccessOk</dt>
		<dd i18n>Изменение успешно отправлено.</dd>
		<dt>checkSignOK</dt>
		<dd i18n>Успешно прошла проверка на целостность и подлинность.</dd>
		<dt>checkSignError</dt>
		<dd i18n>Не прошла проверка на целостность и подлинность.</dd>
		<dt>defaultError</dt>
		<dd i18n>Произошла неизвестная ошибка на стороне сервера.</dd>
		<dt>required</dt>
		<dd i18n>Не заполнено обязательное поле</dd>
		<dt>validationRequired</dt>
		<dd i18n>Заполните все обязательные поля</dd>
		<dt>validationValidity</dt>
		<dd i18n>Данные введены неверно</dd>
		<dt>requiredTrue</dt>
		<dd i18n>Подтвердите, что</dd>
		<dt>registrationError</dt>
		<dd i18n>Ошибка регистрации. Обратитесь к администрации системы.</dd>
		<dt>contractAgree</dt>
		<dd i18n>ознакомились с договором и согласны с условиями</dd>
		<dt>politicsAgree</dt>
		<dd i18n>ознакомились с политикой конфиденциальности</dd>
		<dt>maxlength</dt>
		<dd i18n>Превышена максимальная длина</dd>
		<dt>minlength</dt>
		<dd i18n>Слишком мало символов</dd>
		<dt>notGLN</dt>
		<dd i18n>Не является GLN. Некорректное контрольное число</dd>
		<dt>notEdsProxyPort</dt>
		<dd i18n>Некорректный Порт SC-CryptoProxy. Должно быть меньше 65535</dd>
		<dt>notPositiveEdsProxyPort</dt>
		<dd i18n>Некорректный Порт SC-CryptoProxy. Значение должно быть положительным</dd>
		<dt>email</dt>
		<dd i18n>Некорректный</dd>
		<dt>unavailableSCCryptoProxy</dt>
		<dd i18n>Не удалось подключиться к SC-CryptoProxy</dd>
		<dt>bindProxy</dt>
		<dd i18n>К учетной записи не привязан ни один сертификат ЭЦП. Зайдите в "Мой профиль" и привяжите ЭЦП</dd>
		<dt>bindEdsProxy</dt>
		<dd i18n>Ошибка при подписи. Второе и последующие подписания возможны только с использованием стандартной ЭЦП (не мобильной).</dd>
		<dt>notGTIN</dt>
		<dd i18n>Некорректное контрольное число</dd>
		<dt>userActivationSuccess</dt>
		<dd i18n>Пользователь успешно активирован. Используйте новый пароль для входа в систему</dd>
		<dt>recoveredPasswordSuccess</dt>
		<dd i18n>Пароль успешно изменен. Используйте новый пароль для входа в систему</dd>
		<dt>from</dt>
		<dd i18n>от</dd>
		<dt>lessThan</dt>
		<dd i18n>Дата окончания периода не может быть раньше даты начала периода</dd>
		<dt>lessThanOrEqualTo</dt>
		<dd i18n>Дата окончания периода доставки должна быть позднее даты начала периода доставки</dd>
		<dt>to</dt>
		<dd i18n>до</dd>
		<dt>issued</dt>
		<dd i18n>выданный</dd>
		<dt>certPartyNumber</dt>
		<dd i18n>номер партии</dd>
		<dt>certProductDate</dt>
		<dd i18n>дата производства</dd>
		<dt>checkPeriod</dt>
		<dd i18n>"Дата начала расчетного периода" не может быть больше, чем "Дата окончания расчетного периода"</dd>
		<dt>emailError</dt>
		<dd i18n>Адрес электронной почты указан в неверном формате</dd>
		<dt>createStorageSuccess</dt>
		<dd i18n>Склад успешно добавлен</dd>
		<dt>createStorageError</dt>
		<dd i18n>Склад не может быть добавлен</dd>
		<dt>buyerNotSelected</dt>
		<dd i18n>Покупатель/заказчик не выбран</dd>
		<dt>shipmentBuyerNotSelected</dt>
		<dd i18n>Покупатель не выбран</dd>
		<dt>invalidGtin</dt>
		<dd i18n>Неверный GTIN. Проверьте наличие данного GTIN в базе ePASS.</dd>
		<dt>addProductSuccess</dt>
		<dd i18n>Товар успешно добавлен.</dd>
		<dt>sendParticipantStatementSuccess</dt>
		<dd i18n>Заявление об участнике ЭДО было успешно отправлено. Можете начинать работать с ЭДО.</dd>
		<dt>deletePartyDepartment</dt>
		<dd i18n>Вы действительно хотите удалить подразделение? При удалении все привязанные сотрудники будут автоматически отвязаны от него в системе</dd>
		<dt>partyDepartmentDeleted</dt>
		<dd i18n>Подразделение удалено</dd>
		<dt>partyDepartmentChanged</dt>
		<dd i18n>Изменения по подразделению сохранены</dd>
		<dt>partyDepartmentAdded</dt>
		<dd i18n>Подразделение добавлено</dd>
		<dt>addAnotherSignature</dt>
		<dd i18n>В документе уже присутствует подпись с указанным сертификатом. Добавить повторно?</dd>
		<dt>add</dt>
		<dd i18n>Добавить</dd>
		<dt>executorsListLengthError</dt>
		<dd i18n>Не заполнен обязательный блок "Исполнитель".</dd>
		<dt>stageTemplateListLengthError</dt>
		<dd i18n>Не заполнен обязательный блок "Настройка этапов".</dd>
		<dt>workflowTemplateAdded</dt>
		<dd i18n>Шаблон маршрута добавлен</dd>
		<dt>workflowTemplateChanged</dt>
		<dd i18n>Изменения по шаблону маршрута сохранены</dd>
		<dt>deleteWorkflowTemplate</dt>
		<dd i18n>Вы действительно хотите удалить шаблон маршрута?</dd>
		<dt>workflowTemplateDeleted</dt>
		<dd i18n>Шаблон маршрута согласования удален</dd>
		<dt>organizationFunctionsChanged</dt>
		<dd i18n>Функции организации настроены</dd>

		<dt>synchronizeSuccess</dt>
		<dd i18n>Список товаров актуализирован</dd>
		<dt>productsError</dt>
		<dd i18n>Добавьте товары/услуги</dd>
		<dt>productsEcmrError</dt>
		<dd i18n>Добавьте информацию о грузе</dd>
		<dt>ltsError</dt>
		<dd i18n>Отсуствует сертификат для подписи</dd>
		<dt>saveSuccess</dt>
		<dd i18n>Черновик сохранён</dd>
		<dt>invalid</dt>
		<dd i18n>Невозможно подписать невалидную форму</dd>
		<dt>deletionPopupText</dt>
		<dd i18n>Вы действительно хотите удалить черновик электронного акта?</dd>
		<dt>deletionEwaybillPopupText</dt>
		<dd i18n>Вы действительно хотите удалить черновик электронной накладной?</dd>
		<dt>processSignThenSendPopupText</dt>
		<dd i18n>Вы действительно хотите подписать и отправить электронный акт?</dd>
		<dt>savingEwaybillDraft</dt>
		<dd i18n>Для импорта кодов маркировки необходимо сохранить черновик эНакладной</dd>
		<dt>clearVerificationResults</dt>
		<dd i18n>Результаты предыдущих сверок были удалены.</dd>
		<dt>importNote</dt>
		<dd i18n>При импорте будут удалены все ранее внесённые в черновик накладной коды маркировки!</dd>
		<dt>save</dt>
		<dd i18n>Сохранить</dd>
		<dt>ok</dt>
		<dd i18n>Ок</dd>
		<dt>cancel</dt>
		<dd i18n>Отмена</dd>
		<dt>continue</dt>
		<dd i18n>Продолжить</dd>
		<dt>successfullyCopiedCodes</dt>
		<dd i18n>Коды скопированы в буфер обмена.</dd>
		<dt>successfullyCopied</dt>
		<dd i18n>Текст скопирован в буфер обмена.</dd>

		<dt>versionUpdated</dt>
		<dd i18n>Версия ПО обновлена.</dd>
		<dt>clearCookiesAndFile</dt>
		<dd i18n>Будут очищены временные файлы и файлы cookie.</dd>
		<dt>validationError</dt>
		<dd i18n>Ошибка валидации.</dd>
		<dt>signingDocError</dt>
		<dd i18n>Документ уже подписан.</dd>
		<dt>signingError</dt>
		<dd i18n>Документ не подписан.</dd>
		<dt>sendingError</dt>
		<dd i18n>Ошибка отправки.</dd>
		<dt>signError</dt>
		<dd i18n>Документ не подписан.</dd>
		<dt i18n>internalError</dt>
		<dd i18n>Внутренняя ошибка.</dd>
		<dt>incorrectEmail</dt>
		<dd i18n>Некорректный Email.</dd>
		<dt>wrongUnp</dt>
		<dd i18n>Сертификат (ЭЦП) не соответствует указанной в документе организации</dd>
		<dt>wrongUnpBind</dt>
		<dd i18n>Сертификат ЭЦП не соответствует УНП организации</dd>

		<dt>massActionsError</dt>
		<dd i18n>Действие недоступно для отправленных документов. Выберите только черновики документов</dd>
		<dt>massDeleteActionsError</dt>
		<dd i18n>Действие доступно только для документов в статусе "Черновик" и "Черновик с ЭЦП"</dd>
		<dt>massSignActionsError</dt>
		<dd i18n>Действие доступно только для неподписанных черновиков. Выберите неподписанный черновик.</dd>
		<dt>massSendActionsError</dt>
		<dd i18n>Действие доступно только для черновиков с ЭЦП. Выберите черновик с ЭЦП.</dd>
		<dt>massActionsDraftError</dt>
		<dd i18n>Действие недоступно для подписанных черновиков. Выберите только черновики без ЭЦП</dd>
		<dt>massHandleActionsError</dt>
		<dd i18n>Действие доступно только для документов в статусе "Получен". Выберите только документ в статусе "Получен"</dd>
		<dt>massHandleActionsErrorKz</dt>
		<dd i18n>Действие доступно только для документов в статусе "Получен" и "Передан"</dd>
		<dt>handleActionError</dt>
		<dd i18n>Обработать документ может только грузополучатель</dd>
		<dt>handleActionConfirmReceiptError</dt>
		<dd i18n>Для выбранных документов (или части из них) недоступно подтверждение получения.</dd>
		<dt>massActionsEwaybillMilkRoleError</dt>
		<dd i18n>У вас нет прав для работы с ТТН-молоко.</dd>
		<dt>massActionsDocumentVersionError</dt>
		<dd i18n>Действие доступно только для документов одной версии.</dd>
		<dt>massActionsDocumentOldVersionError</dt>
		<dd i18n>Обработка документов формата по Постановлению № 12/76/42/20 от 19 декабря 2019 г. запрещена.</dd>


		<dt>massActionsExportNotWblDnrError</dt>
		<dd i18n>Для выбранных документов нельзя сформировать реест. Выберите ТТН (кроме экспортной) и/или ТН (иной документ).</dd>
		<dt>massActionsExportNotExtCountryError</dt>
		<dd i18n>Реестр для ТН данного типа сформировать невозможно. Выберите только межстрановые ТН.</dd>
		<dt>massActionsExportErrorMessage</dt>
		<dd i18n>Реестр для экспортных накладных сформировать невозможно. Выберите другой тип накладных.</dd>
		<dt>massActionsExportExportMessage</dt>
		<dd i18n>Выбранные документы содержат как ТТН, так и ТН (иной документ). Формирование реестра возможно только для документов одного вида.</dd>
		<dt>massActionsExportStorageErrorMessage</dt>
		<dd i18n>Выберите ТН (иные документы) с одним местом отгрузки.</dd>

		<dt>markAsReadActionsError</dt>
		<dd i18n>Действие недоступно для прочитанных документов.</dd>
		<dt>massActionsSentError</dt>
		<dd i18n>Документ уже отправлен.</dd>
		<dt>exportError</dt>
		<dd i18n>Экспорт черновиков документов не возможен. Выберите только отправленные документы</dd>
		<dt>exportSentError</dt>
		<dd i18n>Документы в статусе Отправлен(а) еще находятся в обработке. Экспорт будет доступен после завершения обработки и смены статуса.</dd>
		<dt>dataMarkError</dt>
		<dd i18n>Ошибка Электронного знака:</dd>
		<dt>confirmReceiptError</dt>
		<dd i18n>Для выбранных документов (или части из них) недоступно подтверждение получения</dd>
		<dt>markingCodeReport</dt>
		<dd i18n>Отчет о маркировке направлен в ГИС "Электронный знак"</dd>
		<dt>eInvoiceSendError</dt>
		<dd i18n>Действие недоступно для выбранных документов. Выберите только документы "Черновик с ЭЦП"</dd>
		<dt>validationdSenderGLNError</dt>
		<dd i18n>Ошибка валидации: GLN отправителя в сообщении не совпадает с GLN фактически отправившей организации</dd>
		<dt>emptyAroundDot</dt>
		<dd i18n>Некорректное заполнение поля</dd>
		<dt>getEactError</dt>
		<dd i18n>У грузополучателя не включена возможность работы с актами приемки.</dd>
		<dt>passwordNotCorrect</dt>
		<dd i18n>Пароль неверен.</dd>
		<dt>createEdocumentError</dt>
		<dd i18n>Создание электронных документов старого формата не поддерживается. В случае необходимости создайте электронный документ нового формата в разделе «Документы New».</dd>

		<dt>documentNotOpen</dt>
		<dd i18n>Выбранный документ нелья открыть.</dd>
		<dt>yandexDeliveryTokenError</dt>
		<dd i18n>Отсутствует привязанный токен организации в Яндекс Доставка. Заполните на карточке Моя организация.</dd>
		<dt>transinetDeliveryTokenError</dt>
		<dd i18n>Отсутствует привязанный токен организации в Transinet. Заполните на карточке Моя организация.</dd>
		<dt>placesOrProductsError</dt>
		<dd i18n>Не заполнен пункт погрузки, разгрузки или товарный раздел.</dd>
		<dt>transinetPlacesOrProductsError</dt>
		<dd i18n>Не заполнены обязательные поля. Проверьте: дата и номер основания отпуска, пункт погрузки, пункт разгрузки, товарный раздел.</dd>
		<dt>successfulTransinetRegistration</dt>
		<dd i18n>Организация зарегистрирована в Transinet. Разрешена работа с сервисом по созданию заявок.</dd>

		<!-- EACT -->
		<dt>discrepanciesError</dt>
		<dd i18n>В акте приемки отсутствуют товарные позиции с расхождениями.</dd>
		<dt>buyerRepresentativeError</dt>
		<dd i18n>Не указан представитель грузополучателя.</dd>
		<dt>successButtonName</dt>
		<dd i18n>Подписать</dd>
		<dt>cancelButtonName</dt>
		<dd i18n>Отменить</dd>
		<dt>discrepanciesEactMessage</dt>
		<dd i18n>Товарные позиции без расхождений будут удалены системой из акта приемки.</dd>
		<dt>eactDiscrepanciesHeader</dt>
		<dd i18n>Подписание акта</dd>
		<dt>openEact</dt>
		<dd i18n>Открыть Акт приемки</dd>
		<dt>traceableEactItemsRemoved</dt>
		<dd i18n>Прослеживаемые товары в накладной не будут добавлены в Акт приемки</dd>
		<dt>createEactReport</dt>
		<dd i18n>Отчет о создании Акта приемки</dd>

		<dt>minValueError</dt>
		<dd i18n>В товарной позиции № «POSITION» значение в поле «Цена (Данные о прослеживаемости)» должно быть больше нуля.</dd>

		<dt>devFunctionaly</dt>
		<dd i18n>Данный функционал находится в разработке.</dd>
		<dt>removeDocument</dt>
		<dd i18n>Вы действительно хотите удалить STATUS DT?</dd>
		<dt>removeDocumentDraft</dt>
		<dd i18n>Вы действительно хотите удалить черновик документа?</dd>
		<dt>extraMB</dt>
		<dd i18n>Превышен максимальный размер файлов (10 MB).</dd>
		<dt>receiver</dt>
		<dd i18n>Не выбран Получатель.</dd>
		<dt>file</dt>
		<dd i18n>Не выбран Файл.</dd>
		<dt>notValidGTIN</dt>
		<dd i18n>GTIN должен начинаться на 29.</dd>
		<dt>emptyFile</dt>
		<dd i18n>Не выбран документ.</dd>

		<!-- ROSEU annuled -->
		<dt>ANNULMENT</dt>
		<dd i18n>Причина аннулирования</dd>
		<dt>DENY_ANNULMENT</dt>
		<dd i18n>Причина отказа аннулирования</dd>
		<dt>CLARIFICATION</dt>
		<dd i18n>Причина уточнения</dd>
	
		<!-- Roaming requests -->
		<dt>notOneFile</dt>
		<dd i18n>Выберите файл для загрузки.</dd>
		<dt>noCsv</dt>
		<dd i18n>Формат файла не соответствует допустимому.</dd>
		<dt>readingError</dt>
		<dd i18n>Ошибка чтения файла</dd>
		<dt>noFile</dt>
		<dd i18n>Выберите файл</dd>
		<dt>loadingFileError</dt>
		<dd i18n>В загруженной из файла информации о контрагентах присутствуют ошибки. Исправьте их и повторите попытку.</dd>
		<dt>moreOf2000items</dt>
		<dd i18n>Загружено информации более чем о 2000 контрагентах. Процесс оформления запросов на роуминг может занять длительное время. Разбейте файл на несколько частей и повторите загрузку.</dd>

		<dt>periodTitle</dt>
		<dd i18n>Настроить период по-умолчанию можно на вкладке "Мой профиль" в блоке "Параметры периода на начальной странице"</dd>
		<dt>innError</dt>
		<dd i18n>Неверный "ИНН".</dd>
		<dt>kppError</dt>
		<dd i18n>Неверный "КПП".</dd>
		<dt>discrepanciesMessage</dt>
		<dd i18n>Товарные позиции без расхождений будут удалены системой из документа.</dd>
		<dt>ukdDiscrepanciesHeader</dt>
		<dd i18n>Подписание УКД</dd>
		<dt>roseuDiscrepanciesError</dt>
		<dd i18n>В документе отсутствуют товарные позиции с изменениями.</dd>
		<dt>bicError</dt>
		<dd i18n>Неверный</dd>
		<dt>productsLengthError</dt>
		<dd i18n>Добавьте товары</dd>
		<dt>isHasDataMarksError</dt>
		<dd i18n>Функционал сверки кодов вам недоступен. Для подключения обратитесь к своему EDI-провайдеру</dd>
		<dt>unknownError</dt>
		<dd i18n>Произошла неизвестная ошибка.</dd>
		<dt>tokenError</dt>
		<dd i18n>Попытка входа по истекшему токену авторизации! Попробуйте войти повторно.</dd>
		<dt>unavailableNcaProxy</dt>
		<dd i18n>Для работы с ключами электронной цифровой подписи установите программу NCALayer.</dd>
		<dt>unavailableNcaLayer</dt>
		<dd i18n>Не удалось подключиться к NCALayer.</dd>
		<dt>tnvedCodeSearchItemPopup</dt>
		<dd i18n>Введено неверное количество символов для Кода ТН ВЭД. Введите 10 символов.</dd>
		<dt>customCodeSearchItemPopup</dt>
		<dd i18n>"Код по таможенному классификатору" должен содержать точно 4 цифры.</dd>
		<dt>customCodeSearchItemError</dt>
		<dd i18n>Код по таможенному классификатору должен быть прослеживаемым.</dd>
		<dt>updREUSShippingDocumnetError</dt>
		<dd i18n>Необходимо заполнить поля блока "Документы об отгрузке". Блок является обязательным к заполнению для Счета-фактуры.</dd>
		<dt>updNotREUSShippingError</dt>
		<dd i18n>Необходимо заполнить поля блока "Сведения об отгрузке". Блок является обязательным к заполнению по данным Передаточного документа.</dd>
		<dt>unsupportedFileFormatError</dt>
		<dd i18n>Несоответствующий формат файла.</dd>
		<dt>noSupplier</dt>
		<dd i18n>Для добавления товаров необходимо выбрать поставщика.</dd>
		<dt>exactlyOneOfTwoValuesError</dt>
		<dd i18n>Введите верное количество цифр для поля поиска</dd>
		<dt>massCombinePackageLengthError</dt>
		<dd i18n>Выберите два и более документа для создания пакета.</dd>
		<dt>cancelByUser</dt>
		<dd i18n>Отменено пользователем.</dd>
		<dt>removeDocumentFromPackage</dt>
		<dd i18n>Вы действительно хотите извлечь черновик документа из пакета?</dd>
		<dt>saveChanges</dt>
		<dd i18n>Вы внесли изменения, которые не были сохранены.</dd>
		<dt>dontSaveChanges</dt>
		<dd i18n>Продолжить без сохранения?</dd>
		<dt>UNGROUP_ROSEU_PACKAGE</dt>
		<dd i18n>Вы действительно хотите разгруппировать пакет документов?</dd>
		<dt>DELETE_ROSEU_PACKAGE</dt>
		<dd i18n>Вы действительно хотите удалить пакет документов?</dd>
		<dt>joinPackageWithoutUkd</dt>
		<dd i18n>Для объединения в пакет выберите СЧФ, СЧФ ДОП, ДОП или Неформализованный документы.</dd>
		<dt>markAsUnreadSuccess</dt>
		<dd i18n>Документы помечены как непрочитанные.</dd>
		<dt>markAsUnreadError</dt>
		<dd i18n>Действие доступно только для прочитанных документов.</dd>
		<dt>applicationSendMessage</dt>
		<dd i18n>Для того чтобы электронные документы со счетами-фактурами имели юридическую силу и их можно было принять к учету, необходимо отправить заявление об участии в электронном документообороте в ФНС России в соответствии с приказом Минфина РФ от 05.02.2021 № 14н.</dd>
		<dt>applicationSendSubMessage</dt>
		<dd i18n>Отправленное заявление можно просмотреть по переходу на вкладку “Настройки → Моя организация → Заявление участника”.</dd>
		<dt>failActionError</dt>
		<dd i18n>Действия по документу недоступны, дождитесь завершения обработки.</dd>
		<dt>toolTipTNVedMsg</dt>
		<dd i18n>Для выбранного кода ТН ВЭД TNVED требуется указывать код по таможенному классификатору, если товар является прослеживаемым. Пожалуйста, уточните код по таможенному классификатору, чтобы избежать ошибок при отчетности.</dd>

		<!-- EWAYBILL -->
		<dt>dtsTooltipInfo</dt>
		<dd i18n>Просмотреть квитанцию ДТС</dd>
		<dt>deliveryStatusSentMessage</dt>
		<dd i18n>Связанное сообщение отправляется. Обновите страницу</dd>
		<dt>copyEwaybillNumber</dt>
		<dd i18n>Копировать номер накладной</dd>
		<dt>checkDMItemGtin</dt>
		<dd i18n>По нажатию будут проверены GTIN в Кодах маркировки по всем товарным позициям с маркировкой</dd>
		<dt>senderName</dt>
		<dd i18n>Имя отправителя</dd>
		<dt>enterPhone</dt>
		<dd i18n>Введите телефон</dd>
		<dt>phone</dt>
		<dd i18n>Телефон</dd>
		<dt>shipperName</dt>
		<dd i18n>Имя получателя</dd>
		<dt>address</dt>
		<dd i18n>Адрес</dd>
		<dt>name</dt>
		<dd i18n>Имя</dd>
		<dt>unavailablecontactISPConnect</dt>
		<dd i18n>Недоступно. Обратитесь к провайдеру для подключения.</dd>
		<dt>dateAndTime</dt>
		<dd i18n>Дата и время</dd>
		<dt>returnPoint</dt>
		<dd i18n>Пункт возврата</dd>
		<dt>emailPost</dt>
		<dd i18n>Почта</dd>
		<dt>consigneeAccept</dt>
		<dd i18n>Принял грузополучатель</dd>
		<dt>totalNumberEWMarkCodes</dt>
		<dd i18n>Общее количество кодов маркировки в накладной</dd>
		<dt>quantityMatchedFilesEWMarkCodes</dt>
		<dd i18n>Количество кодов маркировки, которые совпадают в накладной и всех импортированных файлах</dd>
		<dt>quantityExistEWMarkCodesNotFiles</dt>
		<dd i18n>Количество кодов маркировки, которые имеются в накладной, но не содержатся в импортированном файле</dd>
		<dt>quantityMarkCodesFormFileNotEW</dt>
		<dd i18n>Количество кодов маркировки из файла, которые не найдены в накладной</dd>
		<dt>searchCodes</dt>
		<dd i18n>Поиск кодов</dd>
		<dt>fileForImport</dt>
		<dd i18n>Файлы для импорта</dd>
		<dt>extraFieldName</dt>
		<dd i18n>Название дополнительного поля</dd>
		<dt>extraFieldValue</dt>
		<dd i18n>Значение дополнительного поля</dd>
		<dt>onlyCode</dt>
		<dd i18n>Код</dd>
		<dt>onlyThem</dt>
		<dd i18n>Свое</dd>
		<dt>onlyValue</dt>
		<dd i18n>Значение</dd>
		<dt>onlyName</dt>
		<dd i18n>Наименование</dd>
		<dt>ewActDate</dt>
		<dd i18n>Дата акта</dd>
		<dt>ewActNumber</dt>
		<dd i18n>Номер акта</dd>
		<dt>ewActName</dt>
		<dd i18n>Наименование акта</dd>
		<dt>ewEactDate</dt>
		<dd i18n>Дата акта приемки</dd>
		<dt>ewEactNumber</dt>
		<dd i18n>Номер акта приемки</dd>
		<dt>ewEactName</dt>
		<dd i18n>Наименование акта приемки</dd>
		<dt>idOrgLabel</dt>
		<dd i18n>УНП, ИНН, БИН и др.</dd>
		<dt>priceNet</dt>
		<dd i18n>Цена (товарный раздел)</dd>
		<dt>fullName</dt>
		<dd i18n>Наименование товара</dd>
		<dt>gtin</dt>
		<dd i18n>GTIN (Товарный раздел)</dd>
		<dt>quantityDespatch</dt>
		<dd i18n>Количество (Товарный раздел)</dd>
		<dt>grossWeight</dt>
		<dd i18n>Масса груза (товарный раздел)</dd>
		<dt>documentDate</dt>
		<dd i18n>Дата документа</dd>
		<dt>documentLineNumber</dt>
		<dd i18n>Номер строки в документе</dd>
		<dt>documentNumber</dt>
		<dd i18n>Номер документа</dd>
		<dt>documentType</dt>
		<dd i18n>Тип документа</dd>
		<dt>consingneeProductsName</dt>
		<dd i18n>Наименование (грузополучатель)</dd>
		<dt>loadingAddress</dt>
		<dd i18n>Адрес пункта погрузки</dd>
		<dt>unloadingAddress</dt>
		<dd i18n>Адрес пункта разгрузки</dd>
		<dt>priceSPT</dt>
		<dd i18n>Цена</dd>
		<dt>customCode</dt>
		<dd i18n>Код ТН ВЭД товара</dd>
		<dt>quantityDespatchedSPT</dt>
		<dd i18n>Количество товара</dd>
		<dt>uom</dt>
		<dd i18n>Единица измерения</dd>
		<!-- EWAYBILL -->

		<!-- ECMR -->
		<dt>consigneeName</dt>
		<dd i18n>Наименование Грузополучателя</dd>
		<dt>carrierName</dt>
		<dd i18n>Наименование перевозчика</dd>
		<dt>peoplePoint</dt>
		<dd i18n>Населенный пункт</dd>
		<dt>shipToAddressFull</dt>
		<dd i18n>Место погрузки Адрес</dd>
		<dt>shipFromAddressFull</dt>
		<dd i18n>Место разгрузки Адрес</dd>
		<dt>loadingInstruction</dt>
		<dd i18n>Оговорки и замечания перевозчика</dd>
		<dt>sealNumber</dt>
		<dd i18n>Номер пломбы</dd>
		<dt>select</dt>
		<dd i18n>Выберите</dd>
		<dt>transportTypeCode</dt>
		<dd i18n>Тип транспортного средства</dd>
		<dt>registrationNumber</dt>
		<dd i18n>Регистрационный номер</dd>
		<dt>mark</dt>
		<dd i18n>Марка</dd>
		<dt>onlyNumber</dt>
		<dd i18n>Номер</dd>
		<dt>onlyStatus</dt>
		<dd i18n>Статус</dd>
		<dt>payerIdentifier</dt>
		<dd i18n>Идентификатор плательщика</dd>
		<dt>extraFieldsName</dt>
		<dd i18n>Наименование (дополнительные поля)</dd>
		<dt>pickUpDateTo</dt>
		<dd i18n>Дата и время погрузки</dd>
		<dt>onlyPickUpTo</dt>
		<dd i18n>Убытие</dd>
		<dt>deliveryDateTo</dt>
		<dd i18n>Дата и время разгрузки</dd>
		<dt>shipFromGln</dt>
		<dd i18n>GLN места погрузки</dd>
		<dt>shipToGln</dt>
		<dd i18n>GLN места разгрузки</dd>
		<dt>pickUpDate</dt>
		<dd i18n>Планируемая дата и время погрузки</dd>
		<dt>onlyEdit</dt>
		<dd i18n>Редактировать</dd>
		<dt>onlyDelete</dt>
		<dd i18n>Удалить</dd>
		<dt>tnvedCode</dt>
		<dd i18n>Код ТН ВЭД</dd>
		<dt>packageType</dt>
		<dd i18n>Вид упаковки</dd>
		<dt>undgCode</dt>
		<dd i18n>Номер опасного груза по ДОПОГ</dd>
		<dt>grossWeightKg</dt>
		<dd i18n>Вес брутто, кг</dd>
		<dt>grossVolume</dt>
		<dd i18n>Объем, м3</dd>
		<dt>quantityPiecesCargo</dt>
		<dd i18n>Количество мест груза</dd>
		<dt>description</dt>
		<dd i18n>Доп. информация</dd>
		<dt>postCode</dt>
		<dd i18n>Почтовый индекс</dd>
		<dt>streetBuild</dt>
		<dd i18n>Улица, дом</dd>
		<dt>definedCargoAmount</dt>
		<dd i18n>Объявленная стоимость груза</dd>
		<dt>equipmentNumber</dt>
		<dd i18n>Номер контейнера или полуприцепа</dd>
		<dt>tradeTerms</dt>
		<dd i18n>Условия оплаты (поставки)</dd>
		<dt>tradeLocation</dt>
		<dd i18n>Название порта, пункта или места</dd>
		<dt>instruction</dt>
		<dd i18n>Описание</dd>
		<dt>cargoName</dt>
		<dd i18n>Наименование груза</dd>
		<!-- ECMR -->

		<dt>lastName</dt>
		<dd i18n>Фамилия</dd>
		<dt>firstName</dt>
		<dd i18n>Имя</dd>
		<dt>middleName</dt>
		<dd i18n>Отчество</dd>
		<dt>jobPost</dt>
		<dd i18n>Должность</dd>
		<dt>scPort</dt>
		<dd i18n>Порт SC-CryptoProxy</dd>
		<dt>scProxyAddress</dt>
		<dd i18n>Адрес SC-CryptoProxy</dd>
		<dt>lcsAddress</dt>
		<dd i18n>Адрес LCS</dd>
		<dt>lcsPassword</dt>
		<dd i18n>Пароль ЭЦП</dd>
		<dt>certificate</dt>
		<dd i18n>Сертификат</dd>
		<dt>iin</dt>
		<dd i18n>ИИН</dd>
		<dt>kpp</dt>
		<dd i18n>КПП</dd>
		<dt>unp</dt>
		<dd i18n>УНП</dd>
		<dt>scCryptoProxyInstruction</dt>
		<dd i18n>Инструкция по установке (обновлению) SC-CryptoProxy</dd>
		<dt>id</dt>
		<dd i18n>Идентификатор</dd>
		<dt>structureBelonging</dt>
		<dd i18n>Структурная принадлежность</dd>
		<dt>directorFullName</dt>
		<dd i18n>Руководитель (ФИО)</dd>
		<dt>directorBase</dt>
		<dd i18n>На основании чего действует</dd>
		<dt>partyCodeInErp</dt>
		<dd i18n>Код в своей УС</dd>
		<dt>ogrn</dt>
		<dd i18n>ОГРН</dd>
		<dt>ogrnip</dt>
		<dd i18n>ОГРНИП</dd>
		<dt>roseuId</dt>
		<dd i18n>Идентификатор участника ЭДО (GUID)</dd>
		<dt>okpo</dt>
		<dd i18n>ОКПО</dd>
		<dt>bankName</dt>
		<dd i18n>Наименование банка</dd>
		<dt>bankAddress</dt>
		<dd i18n>Адрес банка</dd>
		<dt>accountNumber</dt>
		<dd i18n>Расчетный счет</dd>
		<dt>bankCode</dt>
		<dd i18n>Код банка</dd>
		<dt>contactPhone</dt>
		<dd i18n>Контактный телефон</dd>
		<dt>companyGroup</dt>
		<dd i18n>Группа компаний</dd>
		<dt>legalName</dt>
		<dd i18n>Юридическое наименование</dd>
		<dt>inn</dt>
		<dd i18n>ИНН</dd>
		<dt>bin</dt>
		<dd i18n>БИН</dd>
		<dt>taxInspector</dt>
		<dd i18n>Инспекция МНС</dd>
		<dt>nsiOkedName</dt>
		<dd i18n>Основной вид экономической деятельности</dd>
		<dt>transinetEmail</dt>
		<dd i18n>Регистрация на платформе Transinet</dd>
		<dt>password</dt>
		<dd i18n>Пароль</dd>
		<dt>glnStorage</dt>
		<dd i18n>GLN склада</dd>
		<dt>city</dt>
		<dd i18n>Город</dd>
		<dt>yandexIntegrationToken</dt>
		<dd i18n>Токен интеграции с Яндекс Доставкой</dd>
		<dt>expirationIntegrateAccessTokenDate</dt>
		<dd i18n>Дата истечения срока действия токена доступа к интеграционному api</dd>
		<dt>postalCode</dt>
		<dd i18n>Индекс</dd>
		<dt>region</dt>
		<dd i18n>Регион</dd>
		<dt>country</dt>
		<dd i18n>Страна</dd>
		<dt>district</dt>
		<dd i18n>Район</dd>
		<dt>street</dt>
		<dd i18n>Улица</dd>
		<dt>house</dt>
		<dd i18n>Дом</dd>
		<dt>block</dt>
		<dd i18n>Корпус</dd>
		<dt>flat</dt>
		<dd i18n>Офис, квартира</dd>
		<dt>glnOrganization</dt>
		<dd i18n>GLN организации</dd>
		<dt>shortName</dt>
		<dd i18n>Краткое наименование</dd>
		<dt>activeTariff</dt>
		<dd i18n>Активный тариф</dd>
		<dt>arhiveTariff</dt>
		<dd i18n>Архив тарифов</dd>
		<dt>activePackage</dt>
		<dd i18n>Активные пакеты</dd>
		<dt>inactivePackage</dt>
		<dd i18n>Неактивные пакеты</dd>
		<dt>buyTariff</dt>
		<dd i18n>Купить тариф</dd>
		<dt>readMore</dt>
		<dd i18n>Подробнее</dd>
		<dt>buy</dt>
		<dd i18n>Купить</dd>
		<dt>comment</dt>
		<dd i18n>Комментарий</dd>

		<!-- WORKFLOW-TEMPLATE -->
		<dt>executorFullName</dt>
		<dd i18n>ФИО</dd>
		<dt>partyDepartment</dt>
		<dd i18n>Подразделение</dd>
		<dt>term</dt>
		<dd i18n>Срок</dd>
		<dt>priceCountFrom</dt>
		<dd i18n>Сумма От</dd>
		<dt>priceCountTo</dt>
		<dd i18n>Сумма До</dd>
		<dt>automaticWorkflowTooltip</dt>
		<dd i18n>Функционал доступен только для запуска автоматических маршрутов. Для подключения обратитесь к своему провайдеру</dd>
	
		<!-- ROSEU -->
		<dt>orgName</dt>
		<dd i18n>Наименование</dd>
		<dt>orgId</dt>
		<dd i18n>Идентификатор (УНП, ИНН, БИН и др.)</dd>
		<dt>receiverForm</dt>
		<dd i18n>Получатель</dd>
		<dt>documentName</dt>
		<dd i18n>Название документа</dd>
		<dt>post</dt>
		<dd i18n>Должность</dd>
		<dt>signatureDate</dt>
		<dd i18n>Дата подписи</dd>
		<dt>otherInformation</dt>
		<dd i18n>Иные сведения</dd>
		<dt>economicEntityNameResponse</dt>
		<dd i18n>Наименование экономического субъекта – составителя ответа</dd>
		<dt>economicEntityNameDoc</dt>
		<dd i18n>Наименование экономического субъекта – составителя документа</dd>
		<dt>resultCode</dt>
		<dd i18n>Итог принятия товаров</dd>
		<dt>dateAccepted</dt>
		<dd i18n>Дата принятия товаров</dd>
		<dt>additionalInformation</dt>
		<dd i18n>Дополнительные сведения о принятии товаров</dd>
		<dt>organizationName</dt>
		<dd i18n>Наименование организации</dd>
		<dt>partyShipmentAuthority</dt>
		<dd i18n>Основание, по которому организации доверена отгрузка товаров</dd>
		<dt>employeeShipmentAuthority</dt>
		<dd i18n>Основание полномочий представителя организации на отгрузку товаров</dd>
		<dt>subjectShipmentAuthority</dt>
		<dd i18n>Основание, по которому физическому лицу доверена отгрузка товаров</dd>
		<dt>viewMchd</dt>
		<dd i18n>Просмотреть машиночитаемую доверенность</dd>
		<dt>supplier</dt>
		<dd i18n>Продавец</dd>
		<dt>buyer</dt>
		<dd i18n>Покупатель</dd>
		<dt>shipper</dt>
		<dd i18n>Грузоотправитель</dd>
		<dt>consignee</dt>
		<dd i18n>Грузополучатель</dd>
		<dt>sellerSigner</dt>
		<dd i18n>Подписант продавца</dd>
		<dt>buyerSigner</dt>
		<dd i18n>Подписант покупателя</dd>
		<dt>function</dt>
		<dd i18n>Функция документа</dd>
		<dt>currency</dt>
		<dd i18n>Валюта</dd>
		<dt>economicEntityName</dt>
		<dd i18n>Наименование экономического субъекта</dd>
		<dt>powerOfAttorneyBasis</dt>
		<dd i18n>Основание доверенности для составления документа</dd>
		<dt>governmentContractId</dt>
		<dd i18n>Идентификатор гос. контракта</dd>
		<dt>additionalInfo</dt>
		<dd i18n>Дополнительные сведения</dd>
		<dt>itemTypeCode</dt>
		<dd i18n>Код вида товара</dd>
		<dt>registrationGoodsNumber</dt>
		<dd i18n>Регистрационный номер партии товаров</dd>
		<dt>okei</dt>
		<dd i18n>Единица измерения</dd>
		<dt>quantityBefore</dt>
		<dd i18n>Количество до</dd>
		<dt>quantityAfter</dt>
		<dd i18n>Количество после</dd>
		<dt>productName</dt>
		<dd i18n>Наименование товара</dd>
		<dt>vatRate</dt>
		<dd i18n>Ставка НДС, %</dd>
		<dt>quantity</dt>
		<dd i18n>Количество</dd>
		<dt>price</dt>
		<dd i18n>Цена</dd>
		<dt>exciseDuty</dt>
		<dd i18n>Акциз</dd>
		<dt>eventFields</dt>
		<dd i18n>Информационные поля события</dd>
		<dt>addInformation</dt>
		<dd i18n>Добавить информацию</dd>
		<dt>edit</dt>
		<dd i18n>Редактировать</dd>
		<dt>delete</dt>
		<dd i18n>Удалить</dd>
		<dt>withoutExciseDuty</dt>
		<dd i18n>без акциза</dd>
		<dt>withoutExcise</dt>
		<dd i18n>Без акциза</dd>
		<dt>exportMarkingCodesByItem</dt>
		<dd i18n>Выгрузить коды маркировки по товарным позициям</dd>
		<dt>authorityArea</dt>
		<dd i18n>Область полномочий</dd>
		<dt>status</dt>
		<dd i18n>Статус</dd>
		<dt>authorityBasis</dt>
		<dd i18n>Основание полномочий (доверия)</dd>
		<dt>authorityBasisOrganization</dt>
		<dd i18n>Основание полномочий (доверия) организации</dd>
		<dt>signer</dt>
		<dd i18n>Подписант</dd>
		<dt>stateRegistration</dt>
		<dd i18n>Гос. регистрация</dd>
		<dt>documentIdentifier</dt>
		<dd i18n>Номер файла основания</dd>
		<dt>operationContent</dt>
		<dd i18n>Содержание операции</dd>
		<dt>transferDocument</dt>
		<dd i18n>Передаточный документ</dd>
		<dt>basisDocument</dt>
		<dd i18n>Основание корректировки</dd>
		<dt>operationContentDetail</dt>
		<dd i18n>Описание содержания операции</dd>
		<dt>additionalFields</dt>
		<dd i18n>Дополнительные поля</dd>
		<dt>addAdditionalFields</dt>
		<dd i18n>Добавить дополнительные поля</dd>
		<dt>replacementNumber</dt>
		<dd i18n>Номер исправления</dd>
		<dt>replacementDate</dt>
		<dd i18n>Дата исправления</dd>
		<dt>governmentContractIdentifier</dt>
		<dd i18n>Идентификатор государственного контракта, договора (соглашения)</dd>
		<dt>docFormCond</dt>
		<dd i18n>Обстоятельства формирования</dd>
		<dt>primaryDocumentAdditionalInformation</dt>
		<dd i18n>Дополнительные сведения к документу</dd>
		<dt>economicEntityNameDocument</dt>
		<dd i18n>Наименование экономического субъекта - составителя документа (в т.ч. комиссионера или агента)</dd>
		<dt>amount</dt>
		<dd i18n>Стоимость</dd>
		<dt>amountVat</dt>
		<dd i18n>Сумма НДС</dd>
		<dt>amountWithVat</dt>
		<dd i18n>Стоимость c НДС</dd>
		<dt>amountWithoutVat</dt>
		<dd i18n>Стоимость без НДС</dd>
		<dt>totalWithVat</dt>
		<dd i18n>Сумма с НДС</dd>
		<dt>value</dt>
		<dd i18n>Значение</dd>
		<dt>type</dt>
		<dd i18n>Тип</dd>
		<dt>paymentNumber</dt>
		<dd i18n>Номер платежного документа</dd>
		<dt>paymentDate</dt>
		<dd i18n>Дата платежного документа</dd>
		<dt>countryOfOrigin</dt>
		<dd i18n>Страна происхождения</dd>
		<dt>declarationNumber</dt>
		<dd i18n>Номер таможенной декларации</dd>
		<dt>productTraceability</dt>
		<dd i18n>В отношении товаров, подлежащих прослеживаемости, указывается «Прослеж».</dd>
		<dt>article</dt>
		<dd i18n>Артикул</dd>
		<dt>itemCode</dt>
		<dd i18n>Код товара</dd>
		<dt>characteristic</dt>
		<dd i18n>Характеристика</dd>
		<dt>nomenclatureType</dt>
		<dd i18n>Тип номенклатуры</dd>
		<dt>customDeclaration</dt>
		<dd i18n>Сведения о декларации на товары</dd>
		<dt>organization</dt>
		<dd i18n>Организация</dd>
		<dt>organizationInn</dt>
		<dd i18n>ИНН организации</dd>
		<dt>shipmentBasis</dt>
		<dd i18n>Основание для отгрузки</dd>
		<dt>shipmentBasisNumber</dt>
		<dd i18n>Номер основания для отгрузки</dd>
		<dt>shipmentBasisDate</dt>
		<dd i18n>Дата основания для отгрузки</dd>
		<dt>subjectDocumentName</dt>
		<dd i18n>Основание полномочий</dd>
		<dt>subjectDocumentNumber</dt>
		<dd i18n>Номер основания полномочий</dd>
		<dt>subjectDocumentDate</dt>
		<dd i18n>Дата основания полномочий</dd>
		<dt>shipmentDate</dt>
		<dd i18n>Дата отгрузки</dd>
		<dt>shipmentStartDate</dt>
		<dd i18n>Дата начала периода поставки товаров</dd>
		<dt>shipmentEndDate</dt>
		<dd i18n>Дата окончания периода поставки товаров</dd>
		<dt>transportationInformation</dt>
		<dd i18n>Сведения о транспортировке груза</dd>
		<dt>additionalShipmentInfo </dt>
		<dd i18n>Дополнительные сведения об отгрузке</dd>
		<dt>documentInPackage</dt>
		<dd i18n>Данный документ уже добавлен в текущий пакет</dd>
		<dt>stateRegistrationCertificate</dt>
		<dd i18n>Свидетельство о государственной регистрации</dd>
		<dt>accountNum</dt>
		<dd i18n>Р/с</dd>
		<dt>bankIdentificationCode</dt>
		<dd i18n>БИК</dd>
		<dt>bank</dt>
		<dd i18n>Банк</dd>
		<dt>correspondentAccount</dt>
		<dd i18n>К/с</dd>
		<dt>otherContactInfo</dt>
		<dd i18n>Иные данные</dd>
		<dt>fullAddress</dt>
		<dd i18n>Полный адрес</dd>
		<dt>login</dt>
		<dd i18n>Логин</dd>
		<dt>lock</dt>
		<dd i18n>Заблокировать</dd>
		<dt>unlock</dt>
		<dd i18n>Разблокировать</dd>
		<dt>restore</dt>
		<dd i18n>Восстановить</dd>
		<dt>idBinUnp</dt>
		<dd i18n>Идентификатор (БИН, УНП и др.)</dd>
		<dt>orgIdUnpInn</dt>
		<dd i18n>Идентификатор организации (УНП, ИНН и др.)</dd>
		<dt>contactLastName</dt>
		<dd i18n>Фамилия контактного лица</dd>
		<dt>contactFirstName</dt>
		<dd i18n>Имя контактного лица</dd>
		<dt>roseuUUID</dt>
		<dd i18n>Идентификатор участника ЭДО</dd>
		<dt>downloadExampleFile</dt>
		<dd i18n>Пример файла для загрузки</dd>
		<dt>partyIdUnpInnBin</dt>
		<dd i18n>Идентификатор контрагента (УНП, ИНН, БИН и др)</dd>
		<dt>partyName</dt>
		<dd i18n>Наименование контрагента</dd>
		<dt>providerEdoName</dt>
		<dd i18n>Оператор ЭДО контрагента</dd>
		<dt>contactInfoFull</dt>
		<dd i18n>Контактное лицо контрагента (ФИО, должность, телефон)</dd>
		<dt>addInfo</dt>
		<dd i18n>Дополнительная информация</dd>
		<dt>documentID</dt>
		<dd i18n>Системный номер</dd>
		<dt>fileName</dt>
		<dd i18n>Наименование файла</dd>
		<dt>enterLogin</dt>
		<dd i18n>Введите логин</dd>
		<dt></dt>
		<dd i18n></dd>
		<dt></dt>
		<dd i18n></dd>
		<dt></dt>
		<dd i18n></dd>
		<dt></dt>
		<dd i18n></dd>
	</dl>
</template>
